var map = {
	"./de.json": 236159,
	"./en.json": 237266,
	"./es.json": 844030,
	"./fr.json": 516986,
	"./it.json": 710428,
	"./ja.json": 29409,
	"./ko.json": 24508,
	"./pl.json": 653415,
	"./pt.json": 239057,
	"./ru.json": 685404,
	"./uk.json": 515634
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128063;